module.exports = __webpack_public_path__ + "img/grade-2.25ce42d.png";